export const MOCKUP_AIS_LIST = [
  {
    id: -1,
    state: 'Needs Response',
    type: 'regular',
    serial: null,
    wo_number: null,
    remind_date: null,
    urgency: 1,
    urgencyName: 'Standard' as const,
    commentsCount: 0,
    point_type: 'sensor',
    asset_code: 'PF2-20-14',
    location_name: '2nd Floor Machine Room',
    equipment_name: '52-304 Tunnel Dryer Supply Fan South Zone 2',
    component_name: 'DS',
    origin_asset_code: 'PF2-20-14',
    origin_location_name: '2nd Floor Machine Room',
    origin_equipment_name: '52-304 Tunnel Dryer Supply Fan South Zone 2',
    origin_component_name: 'DS',
    facility_offset: -5,
    has_declined_report: false,
    status_type: 4,
    facility_name: 'Park500',
    life_time_value: 49,
    life_time: '1 day before',
    updated_at: '2025-05-07 13:21:55',
    time_created: '2025-05-05 12:21:55',
    is_troubleshooting_hold: 0,
    time_zone: 0,
    sensor_hex: 'A267B1',
    is_viewed: false,
    title: 'Review lubrication practices and ensure proper lubrication',
  },
];
